import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconStarWand: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"star-wand, magic"} maskId="square-filled-radius-0-stroke-1-IconStarWand"><path d="M5.42539 1.63013L6.56851 8.8779L1.38379 14.0695L8.01609 15.1244L3.15945 21.6L3.95945 22.2L8.85776 15.6688L11.9649 21.7575L15.3 15.222L22.546 14.0695L17.3613 8.8779L18.5044 1.63013L11.9649 4.95703L5.42539 1.63013Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconStarWand;
